export default __webpack_public_path__ + "resources/icons/d242-cd10.png";